export default __webpack_public_path__ + "static/media/Classic Brekky Burger- proportioned_170.f966c4f8.jpg";